import wretch from './wretch';
import * as R from 'ramda';

import store from '../store/store';
import notificationActions from '../actions/notifications';
import errorDictionary from './errorDictionary';
import { srsApiUrl } from './apiUrls';
import { createRejectingUnauthorizedHandler } from './requestErrorHandlers';

const notifications = notificationActions(store);
const sendNotification = store.action(notifications.send);
const notifyErrors = (error, request) => {
    const { message, notificationLevel } = parseErrorMessage(error);
    sendNotification(message, { context: notificationLevel });
    return request;
};

const handleUnauthorized = createRejectingUnauthorizedHandler({
    onNotify: notifyErrors,
});

const parseErrorMessage = error => {
    const errorJSON = error.text ? JSON.parse(error.text) : {};
    const currentMessage =
        R.path(['message'], errorJSON) || 'Something went wrong.';
    return (
        errorDictionary[currentMessage] || {
            message: currentMessage,
            notificationLevel: 'danger',
        }
    );
};

const fetchSRS = wretch
    .resolve(_ =>
        _.badRequest((err, req) => notifyErrors(err, req))
            .unauthorized(handleUnauthorized)
            .forbidden((err, req) => notifyErrors(err, req))
            .notFound((err, req) => notifyErrors(err, req))
            .timeout((err, req) => notifyErrors(err, req))
            .internalError((err, req) => notifyErrors(err, req))
            .error(409, (err, req) => notifyErrors(err, req)),
    )
    .url(srsApiUrl);

export default fetchSRS;
